import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { Home, CalendarDays, Gift, CreditCard, User, ClipboardList, History, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { HscLogo } from "@/components/HscLogo";
import { cn } from "@/components/kit";

const MEMBER_NAV = [
  { to: "/member/home", label: "Home", icon: Home },
  { to: "/member/booking", label: "Kelas", icon: CalendarDays },
  { to: "/member/rewards", label: "Rewards", icon: Gift },
  { to: "/member/card", label: "Kartu", icon: CreditCard },
  { to: "/member/profile", label: "Profil", icon: User },
];

const COACH_NAV = [
  { to: "/coach/classes", label: "Kelas", icon: ClipboardList },
  { to: "/coach/history", label: "Riwayat", icon: History },
  { to: "/coach/profile", label: "Profil", icon: User },
];

export default function MobileShell({ role }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const nav = role === "coach" ? COACH_NAV : MEMBER_NAV;
  const doLogout = () => { logout(); navigate("/login", { replace: true }); };

  return (
    <div className="min-h-screen bg-black text-white">
      <div className="mx-auto flex min-h-screen max-w-md flex-col border-x border-[#111] bg-black">
        <header className="sticky top-0 z-20 flex items-center justify-between border-b border-[#1F1F22] bg-black/85 px-4 py-3 backdrop-blur">
          <HscLogo size="text-lg" />
          <button onClick={doLogout} data-testid="logout-button" className="rounded-full p-2 text-[#8E8E93] hover:bg-[#141416]">
            <LogOut className="h-5 w-5" />
          </button>
        </header>

        <main className="flex-1 px-4 pb-28 pt-5">
          <Outlet />
        </main>

        <nav className="fixed bottom-0 left-1/2 z-30 flex w-full max-w-md -translate-x-1/2 items-center justify-around border-t border-[#1F1F22] bg-[#050506]/95 px-2 py-2 backdrop-blur">
          {nav.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.to}
                to={item.to}
                data-testid={`tab-${item.label.toLowerCase()}`}
                className={({ isActive }) =>
                  cn(
                    "flex flex-1 flex-col items-center gap-1 rounded-xl py-1.5 text-[10px] font-medium uppercase tracking-wider transition-colors",
                    isActive ? "text-white" : "text-[#5A5A5F]"
                  )
                }
              >
                {({ isActive }) => (
                  <>
                    <Icon className="h-[22px] w-[22px]" strokeWidth={isActive ? 2.4 : 1.8} />
                    {item.label}
                  </>
                )}
              </NavLink>
            );
          })}
        </nav>
      </div>
      <span className="sr-only">{user?.name}</span>
    </div>
  );
}
